import { Typography, Stack, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';

const msciWords = {
  mci: 'fijos',
  msi: 'sin intereses',
};

export default function MsciDetails({ installments = {}, currency }) {
  const { t } = useTranslation();
  const { number, kind, payment_per_month: paymentPerMonth } = installments;

  return (
    <Stack direction="column" alignItems="flex-end">
      <Typography variant="body3">
        {`${number || installments.payment_plan} pagos ${
          msciWords[kind || installments.payment_type]
        } de ${
          paymentPerMonth || installments.payment_per_month
        } ${currency} mensuales*`}
      </Typography>

      <Link
        href="https://boletia.com/terms-of-purchase"
        target="_blank"
        rel="noopener"
        variant="body3"
        sx={{ color: (theme) => theme.palette.text.disabled }}
      >
        Ver terminos y condiciones{' '}
      </Link>
    </Stack>
  );
}
